import Vue from "vue";
import App from "./App.vue";
import "vue-search-select/dist/VueSearchSelect.css";
import titleMixin from "./common/titleMixin";
import routerManager from "@/router/routerManager";
import routerWidget from "@/router/routerWidget";
import routerShowcase from "@/router/routerShowcase";
import i18n from "./i18n";
import localeMixin from "./common/localeMixin";

Vue.config.productionTip = true;

const host = window.location.host;
const parts = host.split(".");

const router = () => {
    if (parts.includes("manager")) {
        return routerManager;
    } else if (parts.includes("booking")) {
        return routerWidget;
    } else if (parts.includes("showcase")) {
        return routerShowcase;
    } else {
        return routerManager;
    }
};

Vue.mixin(titleMixin);
Vue.mixin(localeMixin);

new Vue({
    router: router(),
    i18n,
    render: h => h(App)
}).$mount("#app");
